import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";
import {showHideScreenSize} from "../../actions/ShowHide";
import {dropShowHide} from "../../actions/dropShowHide";
import {darkTheme} from "../../actions/darkTheme";

const ExternalTitle = ({icon, title, id, tooltip}) => {
    return(
        <Container maxWidth="lg" className="mt-5 mb-3 px-3">
            <Grid container spacing={3} className="">
                <div id={id? id:null}>
                    <Typography variant="h6" color="textSecondary">
                        <img src={icon} width="30" height="30" alt={title || "imagen asociada a titulo"}/> {title}
                        {
                            tooltip && <a href="#" className="tooltip-new">
                                <img src="assets/imagenes/info-icon.png" width="20" height="20" alt={"icono tooltip"}/>
                                    <span> {tooltip}.</span>
                            </a>
                        }
                    </Typography>
                </div>
            </Grid>
        </Container>
    )
};

const mapStateToProps = state => ({
    dark: state.dark
})
export default connect(mapStateToProps, {showHideScreenSize, dropShowHide, darkTheme})(ExternalTitle);
